import {useApi} from "../Api";
import {PagedResponse} from "../types/pagination";
import {buildQueryParams} from "../../utils";
import {
    FormSearchOWAncillaryExceptionModel,
    OWAncillaryExceptionEntityRequest,
    OWAncillaryExceptionEntityResponse
} from "../types/owAncillaryException";

export const useOWAncillaryExceptionRepository = () => {
    const {GET, POST, PUT, DELETE} = useApi();

    const PATH = "/pricing/ancillary-exception";

    function getOWAncillaryException(owAncillaryExceptionId: number): Promise<OWAncillaryExceptionEntityResponse> {
        return GET(`${PATH}?id=${owAncillaryExceptionId}`);
    }

    function getOWAncillaryExceptionInUse(owAncillaryExceptionId: number): Promise<boolean> {
        return GET(`${PATH}/in-use?ancillaryExceptionId=${owAncillaryExceptionId}`);
    }

    function getOWAncillaryExceptionsPaged(filters: FormSearchOWAncillaryExceptionModel): Promise<PagedResponse<OWAncillaryExceptionEntityResponse>> {
        const query = "?";

        const queryParams = buildQueryParams(filters);

        return GET(`${PATH}/filter-ow-exception${queryParams ? query + queryParams : ""}`);
    }

    function putOWAncillaryException(owAncillaryException: OWAncillaryExceptionEntityResponse): Promise<OWAncillaryExceptionEntityResponse> {
        return PUT(`${PATH}`, owAncillaryException);
    }

    function postOWAncillaryException(owAncillaryException: OWAncillaryExceptionEntityRequest): Promise<OWAncillaryExceptionEntityResponse> {
        return POST(`${PATH}`, owAncillaryException);
    }

    function deleteOWAncillaryException(owAncillaryExceptionId: number): Promise<string> {
        return DELETE(`${PATH}?id=${owAncillaryExceptionId}`);
    }

    function terminateOWAncillaryException(owAncillaryExceptionId: number): Promise<OWAncillaryExceptionEntityResponse> {
        return GET(`${PATH}/terminate?id=${owAncillaryExceptionId}`);
    }

    return {
        getOWAncillaryException,
        putOWAncillaryException,
        postOWAncillaryException,
        deleteOWAncillaryException,
        getOWAncillaryExceptionsPaged,
        getOWAncillaryExceptionInUse,
        terminateOWAncillaryException
    };

};

